import { RESET_ALL_STATES } from "../actions/actions";

import {
  VALIDATE_FACE_AUTH_REQUESTS,
  VALIDATE_FACE_AUTH_SUCCESS,
  VALIDATE_FACE_AUTH_FAILURE,
} from "../actions/actionTypes";

const initialState = {
  isLoading: false,
  error: null,
  data: null,
};

const faceAuthReducer = (state = initialState, action) => {
  switch (action.type) {
    case VALIDATE_FACE_AUTH_REQUESTS:
      return { ...state, isLoading: true, error: null };
    case VALIDATE_FACE_AUTH_SUCCESS:
      return { ...state, isLoading: false, data: action.payload };
    case VALIDATE_FACE_AUTH_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    case RESET_ALL_STATES:
      return initialState;
    default:
      return state;
  }
};

export default faceAuthReducer;
